import { render, staticRenderFns } from "./PatientNotification.vue?vue&type=template&id=1c94d5a3&scoped=true"
import script from "./PatientNotification.vue?vue&type=script&lang=js"
export * from "./PatientNotification.vue?vue&type=script&lang=js"
import style0 from "./PatientNotification.vue?vue&type=style&index=0&id=1c94d5a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94d5a3",
  null
  
)

export default component.exports